import { useFormattedAsapTime } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/formats/useFormattedAsapTime'
import { useInitializeAndCleanupTime } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/useInitializeAndCleanupTime'
import { useTime } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/useTime'
import { Time } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import { formatTimedTime } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/utils/formats'
import { fieldStyles } from '@/features/pos/components/OrderFinalization/parts/FormFields/styles'
import Select from '@/features/ui/inputs/components/Select'
import Option from '@/features/ui/inputs/components/Select/parts/Option'
import { useScreenSize } from '@/hooks/screen'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

interface TimeSelectorProps {
    times: Time[]
    onSelect: () => void
}

const TimeSelector: FC<TimeSelectorProps> = ({ times, onSelect }) => {
    const [value, handleChange] = useTime(times)

    const handleSelect = (selectedValue: string) => {
        handleChange(selectedValue)
        onSelect()
    }

    useInitializeAndCleanupTime(times, handleChange)

    const { t } = useTranslation()

    const time = times.find((time) => 'asap' in time)

    const formattedAsapTime = useFormattedAsapTime(time?.asap)

    const screenSize = useScreenSize()

    return (
        <Select
            disabled={times.length <= 1}
            label={t('pos.orderFinalization.inputs.deliveryTime.timeSelectorLabel')}
            placeholder=""
            value={value}
            onValueChange={handleSelect}
            style={screenSize === 'small' && fieldStyles.smallScreenField}
        >
            {times.map((time, index) => (
                <Option key={index} value={index.toString()}>
                    {'asap' in time ? formattedAsapTime! : formatTimedTime(time.timed)}
                </Option>
            ))}
        </Select>
    )
}

export default memo(TimeSelector)
